import axios from "axios";

const REQUEST_TIMEOUT = 30000;

const api = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URL,
  timeout: REQUEST_TIMEOUT,
});

export const getUsuarios = () => {
  return api.get("/");
};

export const downloadExcel = async () => {
  const res = await api.get("/excel", {
    responseType: "blob",
  });

  return res.data;
};
